<template>
    <div>
        <div>
            <el-form :inline="true" :model="form"  style="text-align:left;">
                <el-form-item label="综合查询:">
                    <el-input v-model="form.userName"   placeholder="请输入人员名称" :clearable="true"></el-input>
                </el-form-item>                 
                <el-form-item >
                    <el-button type="primary" plain @click="query()">查询</el-button>  
                    <el-button type="primary" plain @click="personnelEditor('add')">新建</el-button>                         
                </el-form-item>           
            </el-form>
        </div>
        <div>
            <My-table :configurationData="configurationData" :operation="operation" :getTableParam="getTableParam" ref="myTable">           
                <template #operation="scope">        
                    <el-button size="mini" type="primary" @click="personnelEditor('update',scope.row)">修改</el-button>
                </template>
            </My-table> 
        </div>
        <el-dialog :title="title"  :visible.sync="personnelEditorDialog" :close-on-click-modal="false" width="1200px">
            <el-form :model="editorForm"  :inline="true" :rules="rules" ref="editorForm" label-width="100px" style="text-align:left">
                <el-row>
                    <el-col :span="12">
                        <el-form-item label="姓名:" prop="userName" class="username-input">
                            <el-input v-model="editorForm.userName" placeholder="请输入姓名" :clearable="true"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="电话号码:" prop="userPhone" class="phone-input">
                            <el-input v-model="editorForm.userPhone" placeholder="请输入电话号码" :clearable="true"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="12">
                        <el-form-item label="角色权限:" prop="roleCode" class="role-select">
                             <My-Select v-model="editorForm.roleCode" :objSelect="editorForm.roleCode" :placeholder="placeholder"  :optionBind="optionBindRole"
                             :options="roleList"  @changeSelct="changeSelct"></My-Select>  
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="状态:" prop="state">
                            <el-switch v-model="editorForm.state"></el-switch>
                        </el-form-item>    
                    </el-col>
                </el-row>
                <el-row>
                    <el-col>
                        <el-form-item label="承销商:" prop="agentCode">
                            <el-checkbox-group v-model="underwriterCheckList" @change="handleCheckedCitiesChange" >
                                <el-checkbox v-for="(item,index) in underwriterList" :label="item.agentCode" :key="index">{{item.agentName}}</el-checkbox>
                            </el-checkbox-group>
                        </el-form-item>
                    </el-col>
                </el-row> 
            </el-form>
          
            <div slot="footer" style="text-align:center">
                <el-button type="primary" @click="submitForm('editorForm')">确定</el-button>
                <el-button @click="resetForm('editorForm')">取消</el-button>
            </div>
        </el-dialog>  
    </div>
</template>

<script>
import common from '../../../public/static/common';

export default { 

    name: 'personnelManagement',
    data(){
        return{
            optionBindRole:{
                label:"roleName",
                value:"roleCode"
            },
            title:'',
            placeholder:'请选择角色权限',
            underwriterCheckList:[],
            underwriterList:[],
            operationType:'',
            form:{
                userName:''
            },
             // 列表配置
            configurationData:[
                {
                    title: '人员名称',
                    propertys: 'userName',
                    width: ''
                },
                {
                    title: '人员电话',
                    propertys: 'userPhone',
                    width: ''
                },{
                    title: '角色名称',
                    propertys: 'roleName',
                    width: ''
                },
                {
                    title: '状态',
                    propertys: 'state',
                    width: '',
                    format:common.formatState
                }
            ],
             // 是否有操作按钮 宽度
            operation: {
                show: true,
                width: ''
            },
            getTableParam:{
                url:'/extwarapi/api/user/page',
                param:''
            },
            personnelEditorDialog:false,
            roleList:[],
            editorForm:{
                id:'',
                userName:'',              
                userPhone:'',
                roleCode:'',
                agentCode:[],
                agentName:[],
                state:true,
                createUser:'',
                modifyUser:'',
                sysCode:'PC'//人员管理都是PC端用户
            },
            rules: {
                userName: [
                    { required: true, message: '请输入姓名', trigger: 'blur' }
                ],
                userPhone: [
                    { required: true, message: '请输入电话号码/手机号格式不正确', pattern: /^1[3456789]\d{9}$/, trigger: 'blur' }
                ],
                roleCode: [
                    { required: true, message: '请选择角色权限', trigger: 'blur' }
                ],
                agentCode: [
                    { required: true, message: '请选择承销商', trigger: 'blur' }
                ],
                state: [
                    { required: true, message: '请选择状态', trigger: 'blur' }
                ]
            }
            
        }
    },
    methods:{
        personnelEditor(operationType,row){
             this.operationType=operationType;
            //console.log('personnel',operationType,row)
            if(operationType=='update'){   
                this.title='人员修改';            
                this.editorForm.id=row.id;
                this.editorForm.userName=row.userName;
                this.editorForm.userPhone=row.userPhone;
                this.editorForm.userCode=row.userCode;
                this.editorForm.roleCode=row.roleCode;
                this.underwriterCheckList=row.agentCode;
                this.editorForm.agentCode=row.agentCode;
                this.editorForm.sysCode="PC";
                if(row.state=='Y'){
                    this.editorForm.state=true;
                }else{
                    this.editorForm.state=false;
                }
            }else{
                //添加
                this.title='人员新增'; 
                this.editorForm.state=true;                
                this.underwriterCheckList=[];
                this.editorForm=common.emptyModel(this.editorForm,["state"]);
            }
            this.personnelEditorDialog=true;
        },
        query(){
            this.getTableParam.param=this.form;
            this.$refs["myTable"].query(1);
        },
        getUnderwriterList(){
            let url="/extwarapi/api/agent/getAgentEnum";
            this.axios.post(url, {}).then((resp) => {               
                    if(resp.data.code=='0000'){                            
                        this.underwriterList=resp.data.result;  
                    }
                }).catch((resp) => {
                    //console.log('error', resp); 
                })
        },
        handleCheckedCitiesChange(value) {
            this.editorForm.agentCode=value;
            this.editorForm.agentName=this.getVbyK(this.underwriterList,value);
        },
       	getVbyK(list,value){
            let names=[];
            for(let j=0;j<value.length;j++){
                let val = value[j];
                for(let i=0;i<list.length;i++){
                    let item = list[i];
                    if(item.agentCode== val){
                        names.push(item.agentName);
                        break;
                    }                    
                }
            }
            return names;
	    },
        submitForm(formName) {
            let usercode=common.getCurrUser().userCode;
            let url="";
            let param=Object.assign({},this.editorForm);
            param.createUser=usercode;
            param.modifyUser=usercode;
            if(param.state){
                param.state='Y'
            }else{
                param.state='N'
            }
            if(this.operationType=='add'){
                url="/extwarapi/api/user/add";
            }else{
                url="/extwarapi/api/user/update";
            }
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    this.axios.post(url, param).then((resp) => {
                        if(resp.data.code=='0000'){
                            this.$alert("操作成功!", '提示信息', {
                                confirmButtonText: '确定',
                                callback: action => {
                                    this.personnelEditorDialog=false;
                                    this.$refs["myTable"].query(1);
                                }
                            });
                        }else{
                            this.$alert(resp.data.msg, '提示信息', {
                                confirmButtonText: '确定',
                                callback: action => {
                                
                                }
                             });
                            return;
                        }
                    }).catch((resp) => {
                        //console.log('error', resp); 
                    })
                } else {
                    //console.log('error submit!!');
                    return false;
                }
            });
        },
        changeSelct(value){
            this.editorForm.roleCode=value;
        },
        resetForm(formName){
           this.personnelEditorDialog=false;
           this.$refs[formName].resetFields(); 
        },
        getRoleList(){
            let url='/extwarapi/api/user/getRoles';
            this.axios.post(url, {}).then((resp) => { 
                    if(resp.data.code='0000'){
                        this.roleList=resp.data.result; 
                    }                                  
                }).catch((resp) => {
                    //console.log('error', resp); 
                })
        }
    },
    mounted(){
        this.getUnderwriterList();
        this.getRoleList();
    }
 
}
</script>
<style lang="scss" >
.username-input .el-input{
    width: 300px;
}
.role-select  .el-input--suffix{
    width: 300px;
}
.phone-input .el-input{
    width: 300px;
}
</style>